import { action, observable } from 'mobx'
import { AccountRequest } from '../requests/AccountRequest'
import { CommandRequest } from '../requests/CommandRequest'

class AccountEditStore {
  /** Command list */
  @observable userCommands = []
  @action getCommandsByUser = userCode => {
    return new Promise((resolve, reject) => {
      CommandRequest.getCommandsByUser(userCode)
        .then(response => {
          this.userCommands = response.data
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  /** Account list */
  @observable accountList = []
  @action getAccountsByUserCode = userCode => {
    return new Promise((resolve, reject) => {
      AccountRequest.getAccountsByUserCode(userCode)
        .then(response => {
          this.accountList = response.data
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  @action updateAccountById = (accountId, accountInfo) => {
    return new Promise((resolve, reject) => {
      AccountRequest.updateAccountById(accountId, accountInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  @action deleteAccountById = accountId => {
    return new Promise((resolve, reject) => {
      AccountRequest.deleteAccountById(accountId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }
  @action createAccount = accountInfo => {
    return new Promise((resolve, reject) => {
      AccountRequest.createAccount(accountInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  @action setActiveAccount = accountId => {
    return new Promise((resolve, reject) => {
      AccountRequest.switchAccount(accountId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  /** Clear store */
  @action clearStore = () => {
    this.accountList.length = 0
    this.userCommands.length = 0
  }
}

export default new AccountEditStore()
